import { Trans, useTranslation } from 'react-i18next';
import ComposedChart from '../ComposedChart';
import { BlockHeader } from '../../BlockHeader';
import { CompanyDataRow } from '../../CompanyDataCard';
import { ReactComponent as NoteIcon } from 'assets/img/icons/cardIcons/note.svg';
import { ReactComponent as DataSourceIcon } from 'assets/img/icons/cardIcons/dataSource.svg';
import React from 'react';
import { Col, Row } from 'antd';
import useIsUiHidden from 'hooks/dom/useIsUiHidden';

export const SocialSecurityGraph = ({ chartData }) => {
  const { t } = useTranslation();
  const isUiHidden = useIsUiHidden();

  const processChartData = (data, t) => {
    const groupedData = {};
    const yearsSet = new Set();
    data.forEach(item => {
      const date = new Date(item.importDate);
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      yearsSet.add(year);
      if (!groupedData[month]) {
        groupedData[month] = { month: month.toString() };
      }
      groupedData[month][year] = item.socialInsuranceContributionsAmount || 0;
    });
    const yearsArray = Array.from(yearsSet).sort((a, b) => b - a);
    const monthsArray = [];
    for (let month = 1; month <= 12; month++) {
      const monthData = { month: t(`global.month.${month}`) };
      yearsArray.forEach(year => {
        monthData[year] = groupedData[month]?.[year] || 0;
      });
      monthsArray.push(monthData);
    }
    return { data: monthsArray, yearsArray };
  };
  const { data: processedData, yearsArray } = processChartData(chartData, t);
  const chartColors = ['#333333', '#999999', '#C9C9C9'];
  const createSeriesConfig = (yearsArray, colorPalette) => {
    return yearsArray.map((year, index) => ({
      type: 'bar',
      dataKey: year.toString(),
      fill: colorPalette[index % colorPalette.length],
    }));
  };
  const series = createSeriesConfig(yearsArray, chartColors);
  return (
    <>
      <ComposedChart
        id="socialSecurity"
        xAxisDataKey={'month'}
        series={series}
        data={processedData}
        showLegend={false}
        lazyLoaded
        noLabelFormating
        noValueFormatiing
        noTranslation
        hideLabels
      />
      <Row gutter={[16]} justify="space-between">
        <Col>
          <BlockHeader title={t('global.note')} icon={<NoteIcon />} />
          <CompanyDataRow
            extraClass="space-bottom-sm fs-12"
            disclaimer={t('professionalReport.basicData.socialSecurityChart.note')}
          />
        </Col>
        <Col style={{ width: 190 }}>
          <BlockHeader title={t('global.dataSource')} icon={<DataSourceIcon />} />
          <CompanyDataRow
            extraClass="fs-12"
            disclaimer={t('professionalReport.basicData.socialSecurityChart.source')}
          />
        </Col>
      </Row>
    </>
  );
};
